import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from "react-dom/client";
import { RecoilRoot } from "recoil";
import { GlobalStyle } from "./components/styles";
import { StyledEngineProvider } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import { routes } from "routes";

import { ThemeProvider } from "styled-components";
import { theme } from "config/theme/theme";

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <RecoilRoot>
    {/* mui styled-components 스타일링 */}
    <StyledEngineProvider injectFirst>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <RouterProvider router={routes} />
      </ThemeProvider>
    </StyledEngineProvider>
  </RecoilRoot>
);
